// extracted by mini-css-extract-plugin
module.exports = {"root":"product-image_root__Oyin8"};